import React from 'react';
import { Route, Routes, useParams } from 'react-router-dom';
import PhaseFormForm from './PhaseFormForm';
import PhaseFormList from './PhaseFormList';
import { SubprocessList } from './SubprocessList';

const SubprocessListWrapper = () => {
  const { id } = useParams();
  return <SubprocessList phaseId={id!} />;
};

export const PhaseFormRoutes = () => {
  return (
    <Routes>
      <Route path="/" element={<PhaseFormList />} />
      <Route path="/new" element={<PhaseFormForm />} />
      <Route path="/:id/subprocesses" element={<SubprocessListWrapper />} />
      <Route path="/edit/:id" element={<PhaseFormForm />} />
      <Route path="/:id" element={<PhaseFormForm />} />
    </Routes>
  );
}; 